module.exports = __webpack_public_path__ + "images/home/product/mobile/features-timeline-996e411632ee0558941ddc5fbeb6a04f.png";